export default "__VITE_ASSET__ClWSsTYG__"